export default __webpack_public_path__ + "static/media/grandma4.b5f9b00b.jpg";